export default class SideMenuToggle {
  /**
  ** 実行
  ** @constructor
  **/    
  constructor() {
    this.getParam()
    this.bindEvent()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/    
  getParam() {
    // MoreBTN
    this.sideAc = document.querySelectorAll(`[data-module='side-acc']`)
    this.sideParent = document.querySelectorAll(`.l-sidebar__parent`)
    this.sideParentNodeList = [].slice.call(this.sideParent)[0]
    this.HideNum = this.sideParentNodeList.getAttribute('data-listnum')
    this.closeTxt = '閉じる'
    this.openTxt = 'もっと見る'
    this.BClass = 'is-show'
    this.LClass = 'is-hide'
    this.MQL = window.matchMedia('(max-width: 750px)');
    this.NavCont = document.querySelector(`[data-module='heightChange']`)
  }


  /**
  ** サイドメニューをトグルするオブジェクト
  ** data-listnumの値を取得、その数値移行のアイテムをhideし、トグルクリックで表示・非表示
  ** @bindEvent
  **/   
 bindEvent() {

  var mql = window.matchMedia('(max-width: 768px)');

  const Event = (e) => {
    if (e.matches) {
      const
        toggle = document.querySelectorAll(`[data-module='nav-tap-toggle']`),
        toggleArray = Array.prototype.slice.call(toggle)
      

      Array.prototype.forEach.call(toggleArray,(elem)=>{
        elem.addEventListener('click', ()=> {
          elem.nextElementSibling.classList.toggle('is-show')
          elem.classList.toggle('is-open')
          var
            backheight = document.querySelector('.l-sidebar__cnt--sp').clientHeight,
            headingHeight = this.NavCont.querySelector('.c-heading__02').clientHeight
          this.NavCont.style.height = backheight + headingHeight + 50 + 'px'          
        })        
      })      
      /* the viewport is 600 pixels wide or less */
    } else {
      Array.prototype.forEach.call(this.sideAc,(elem)=>{
        let
          AccToggle = elem.querySelector(`[data-module='nav-acc-toggle']`),
          ACCList = elem.querySelectorAll('.l-sidebar__parent > li')

        //配列
        ACCList = [].slice.call(ACCList);

        //変数
        let
          HideList = ACCList.slice(this.HideNum)


        // リストでN個目以上にis-hideを付与して非表示に
        HideList.forEach((ACCList)=>{
          if(!ACCList.classList.contains(this.LClass))
            ACCList.classList.add(this.LClass)
        })

        if(AccToggle) {
          //clickEvent
          AccToggle.addEventListener('click',()=> {

            if(AccToggle.classList.contains(this.BClass)) {
              AccToggle.classList.remove(this.BClass)
              AccToggle.innerText = this.openTxt
            } else {
              AccToggle.classList.add(this.BClass)
              AccToggle.innerText = this.closeTxt
            }
            
            HideList.forEach((List)=>{
              if(List.classList.contains(this.LClass))
                List.classList.remove(this.LClass)
              else
                List.classList.add(this.LClass)
            })
          })
        }
      })      
      /* the viewport is more than than 600 pixels wide */
    }
  }
  
  this.MQL.addListener(Event);
  Event(this.MQL)  




  }


}